import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseControlValueAccessor } from "../base_control_value_accessor/base";

@Component({
    selector: 'logzy-multi-field',
    templateUrl: './multi-field.component.html',
    styleUrls: ['./multi-field.component.scss', '../form-field.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => MultiFieldComponent),
        }
    ]
})
export class MultiFieldComponent extends BaseControlValueAccessor implements OnInit {

    @Input()
    amount: number = 0.0;

    @Input()
    currencyCode: string;

    @Input()
    percent: number = 0.0;

    @Input()
    selectField: string = 'price';

    @Output()
    amountChange = new EventEmitter<number>();

    @Output()
    currencyCodeChange = new EventEmitter<string>();

    @Output()
    percentChange = new EventEmitter<number>();

    @Output()
    selectFieldChange = new EventEmitter<string>();

    constructor() {
        super();
    }

    ngOnInit(): void {
    }

    setAmount(amt) {
        this.amount = amt;
        this.amountChange.emit(amt);
    }

    setCurrency(curr) {
        this.currencyCode = curr;
        this.currencyCodeChange.emit(curr);
    }

    setPercentage(percent) {
        this.percent = percent;
        this.percentChange.emit(percent);
    }

    setSelectField(str) {
        this.selectField = str;
        this.selectFieldChange.emit(str);
    }

    getDisplay() {
        if (this.amount != null) {
            return `${this.amount} ${this.currencyCode}`
        } else {
            return '-'
        }
    }
}
